
export class LiquidConstants
{
    }
